var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tel-fab"},[_c('div',{staticClass:"tel-fab-pc"},[_c('div',[_vm._v(_vm._s(_vm.telNumber)),_c('p',[_vm._v(_vm._s(_vm.availableMessage))])])]),_vm._v(" "),_c('div',{staticClass:"tel-fab-mobile"},[_c('div',{staticClass:"tel-fab-badge"},[_vm._v(_vm._s(_vm.availableMessage))]),_vm._v(" "),_c('a',{attrs:{"href":'tel:'+_vm.telNumber}},[_vm._v("전화문의")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a788f7","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TelFab.vue
// module id = 1076
// module chunks = 1